import React from 'react'
import Button from '../Button'

const ExternalLinkButton = props => (
  <Button element='a' target='_blank' rel='noopener noreferrer' role='link' {...props} />
)

export default ExternalLinkButton
